import React from "react";
import { UserToken } from "../../amorg-common";
import { Grid, Flex } from "../../designSystem/compositeComponents/FlexHelpers";
import { Icon } from "../../designSystem/icons/Icons";
import { SingleColumnLayout } from "../../designSystem/layouts/SingleColumnLayout";
import { PageHeader } from "../../designSystem/PageHeader";
import { H3 } from "../../designSystem/typography/Heading";
import { ProtectedPageContext } from "../_contexts/ProtectedPageContext";
import { CardButton } from "../../designSystem/CardButton";


export function SupportListingView():JSX.Element
{
    const context = React.useContext(ProtectedPageContext);
    const activeUser: UserToken | null = context?.user ?? null;
    const showSupportCrecea = activeUser?.features.includes('Articles') && context.user.partner === 'Crecea';

    const handleGoToSupport = () => {
        window.open("https://amorg.dk/support/lovservice", "_blank");
    }

    const handleGoToContact = () => {
        window.location.href = "/support/contact";
    }

    return (
        <SingleColumnLayout
                noDivider
                contentContainer={
                    <>
                        <PageHeader
                            headerIcon={"support"}
                            headerText={"Support"}
                            headerStyle="secondary-gray"
                            
                        />

                        <Grid gridTemplateColumns={2} gap={16}>

                            {showSupportCrecea && (
                            <CardButton variant="outlined" onClick={ () => handleGoToSupport()}>
                                <Flex flexDirection='row' gap={16} alignItems='center'>
                                    <Icon name={"gavel"}  size='medium' color={"black"} />
                                    <Flex flexDirection='column' gap={8}>
                                        <H3>Lovservice 2.0</H3>
                                    </Flex>
                                </Flex>
                            </CardButton>
                            )}
                           <CardButton variant="outlined" onClick={ () => handleGoToContact()}>
                                <Flex flexDirection='row' gap={16} alignItems='center'>
                                    <Icon name={"interface_actions_mail"}  size='medium' color={"black"} />
                                    <Flex flexDirection='column' gap={8}>
                                        <H3>Kontakt</H3>
                                    </Flex>
                                </Flex>
                            </CardButton>
                        </Grid>

                        
                    </>
                }
            />
    );
}